import { Link } from "@remix-run/react";
import styles from "./Footer.module.css";

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.grid}>

        {/* Brand */}
        <div>
          <span className={styles.brandLogo}>PRODIGIUM DYNAMICS</span>
          <span className={styles.brandTag}>The Science of Vision</span>
          <p className={styles.brandDesc}>
            An AI-driven studio building digital products, content systems, and connection layers
            for a multilingual world. Precision over noise. Depth over reach.
          </p>
          <div className={styles.contactLine}>
            <span>●</span>
            <a href="mailto:global@prodigiumdynamics.space">global@prodigiumdynamics.space</a>
          </div>
          <div className={styles.contactLine}>
            <span>●</span>
            <a href="https://t.me/prodigiumdynamics" target="_blank" rel="noopener">
              Telegram — Customer Support
            </a>
          </div>
          <div className={styles.socials}>
            <span className={styles.socialLink} style={{ opacity: 0.45, cursor: "default" }}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <rect x="2" y="2" width="20" height="20" rx="5" />
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
              </svg>
              Instagram — Soon
            </span>
            <span className={styles.socialLink} style={{ opacity: 0.45, cursor: "default" }}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
              </svg>
              TikTok — Soon
            </span>
          </div>
        </div>

        {/* Company */}
        <div>
          <p className={styles.colTitle}>Company</p>
          <div className={styles.colLinks}>
            <Link to="/studio#about" className={styles.colLink}><span className={styles.colLinkDot}>●</span> About</Link>
            <Link to="/about" className={styles.colLink}><span className={styles.colLinkDot}>●</span> About — Full</Link>
            <Link to="/studio#manifesto" className={styles.colLink}><span className={styles.colLinkDot}>●</span> Manifesto</Link>
            <Link to="/press" className={styles.colLink}><span className={styles.colLinkDot}>●</span> Press Kit</Link>
            <Link to="/blog" className={styles.colLink}><span className={styles.colLinkDot}>●</span> Blog</Link>
          </div>
        </div>

        {/* Products */}
        <div>
          <p className={styles.colTitle}>Products</p>
          <div className={styles.colLinks}>
            <Link to="/pageburn" className={styles.colLink}><span className={styles.colLinkDot}>●</span> PageBurn</Link>
            <a href="https://pageburn.site" target="_blank" rel="noopener" className={styles.colLink}><span className={styles.colLinkDot}>●</span> pageburn.site ↗</a>
            <Link to="/pageburn/guide" className={styles.colLink}><span className={styles.colLinkDot}>●</span> PageBurn Guide</Link>
            <Link to="/skillarq" className={`${styles.colLink} ${styles.activeLink}`}><span className={styles.colLinkDot}>●</span> Skillarq</Link>
            <Link to="/brubri" className={styles.colLink}><span className={styles.colLinkDot}>●</span> Brubri</Link>
            <Link to="/burn-rate" className={styles.colLink}><span className={styles.colLinkDot}>●</span> Burn Rate</Link>
            <span className={`${styles.colLink} ${styles.soonSpan}`}><span className={styles.colLinkDot}>●</span> Naomi <span className={styles.soonBadge}>SOON</span></span>
            <span className={`${styles.colLink} ${styles.soonSpan}`}><span className={styles.colLinkDot}>●</span> ░░░░░░░ <span className={styles.soonBadge}>CLASSIFIED</span></span>
          </div>
        </div>

        {/* Legal */}
        <div>
          <p className={styles.colTitle}>Legal</p>
          <div className={styles.colLinks}>
            <Link to="/contact" className={styles.colLink}><span className={styles.colLinkDot}>●</span> Contact</Link>
            <span className={`${styles.colLink} ${styles.soonSpan}`}><span className={styles.colLinkDot}>●</span> Privacy Policy <span className={styles.soonBadge}>SOON</span></span>
            <span className={`${styles.colLink} ${styles.soonSpan}`}><span className={styles.colLinkDot}>●</span> Terms of Use <span className={styles.soonBadge}>SOON</span></span>
            <span className={`${styles.colLink} ${styles.soonSpan}`}><span className={styles.colLinkDot}>●</span> Cookie Policy <span className={styles.soonBadge}>SOON</span></span>
          </div>
        </div>

      </div>

      <div className={styles.divider} />

      <div className={styles.bottom}>
        <div>
          <span className={styles.reg}>Prodigium Dynamics · Est. 2026 · Global Operations</span>
          <span className={styles.copy}>© 2026 Prodigium Dynamics — All rights reserved</span>
        </div>
        <div className={styles.legalLinks}>
          <span className={styles.legalLink} style={{ opacity: 0.45 }}>Privacy</span>
          <span className={styles.legalSep}>·</span>
          <span className={styles.legalLink} style={{ opacity: 0.45 }}>Terms</span>
          <span className={styles.legalSep}>·</span>
          <span className={styles.legalLink} style={{ opacity: 0.45 }}>Cookies</span>
        </div>
      </div>
    </footer>
  );
}
